/**
 * Our API providers don't have latency guarantees, so we need to disable.
 * Otherwise our p95s throw unecessary errors.
 *
 * If you have concerns or questions, please contact @john-michael-murphy
 */
export const DO_NOT_CHANGE_TIMEOUT = 0;
export const DO_NOT_CHANGE_NUM_RETRIES = 1;
/**
 * We don't want to add the client version query param to the URL because it causes unnecessary cache splitting!
 */
export const DO_NOT_CHANGE_NO_CLIENT_VERSION = true;
export const REASON = 'finance';
//# sourceMappingURL=constants.js.map